@if (options.length) {
<eco-fab-speed-dial [(open)]="fabOpen" (openChange)="onOpenChange($event)" class="floatDefault">
    <eco-fab-speed-dial-trigger [spin]="true">
        <button mat-fab class="spin180">
            <mat-icon>{{ fabOpen ? 'close' : 'add' }}</mat-icon>
        </button>
    </eco-fab-speed-dial-trigger>
    <eco-fab-speed-dial-actions>
        @if (showLabels && fabOpen) { @for (option of options; track option) {
        <button
            mat-mini-fab
            (click)="optionClick(option)"
            [style.background-color]="option?.backgroundColor"
            [style.color]="option?.color"
        >
            @if (showLabels && fabOpen) {
            <span class="tooltiptext" [ngClass]="labelsPosition">
                {{ option.label }}
            </span>
            } @if (!option.iconSource || option.iconSource == MATERIAL) {
            <mat-icon>
                {{ option.icon }}
            </mat-icon>
            } @if (option?.iconSource == FONT_AWESOME) {
            <mat-icon class="custom-icon" [svgIcon]="option.icon"> </mat-icon>
            }
        </button>
        } }
    </eco-fab-speed-dial-actions>
</eco-fab-speed-dial>
}
